import { render, staticRenderFns } from "./reservationSetting.vue?vue&type=template&id=0422d800&scoped=true&"
import script from "./reservationSetting.vue?vue&type=script&lang=js&"
export * from "./reservationSetting.vue?vue&type=script&lang=js&"
import style0 from "./reservationSetting.vue?vue&type=style&index=0&id=0422d800&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422d800",
  null
  
)

export default component.exports